import currency from "currency.js";
import React from "react";

const RenderFees = ({ ppvFees }) => {
    if (Object.keys(ppvFees).length > 0) {
        if (ppvFees.fees && !!ppvFees.reg_gst && ppvFees.gst > 0) {
            return <div className="ppv-chrg-text mb-1">
                {currency(ppvFees.fees).format()} processing fee plus {currency(ppvFees.gst).format()} GST will apply.
            </div>;
        } else {
            return <div className="ppv-chrg-text mb-1">{currency(ppvFees.fees).format()} processing fee will apply.</div>;
        }
    }

    return '';
};


export default RenderFees;
